import { mapGetters } from 'vuex';
import Pagination from '@/components/pagination/index.vue';
import AssetsService from '../service.js';
import Service from '@/service/index.js';

export default {
  components: {
    Pagination
  },
  data () {
    return {
      listShow: true,
      activeName: '0',
      pageType: '',
      total: 0,
      tableList: [],
      Assetslist: [],
      projectType: '1',
      assetsLargeTypearr: [],
      projectTypeArr: [],
      projectSubTypeArr: [],
      subTypeObj: {},
      TypeObj: {},
      searchForm: {
        pageNum: 1,
        pageSize: 5,
        type: 0
      },
      assetsStatusArr: [
        { code: 0, value: '可用' },
        { code: 1, value: '审核中' },
        { code: 2, value: '交易中' },
        { code: 3, value: '已流转' },
        { code: 4, value: '已到期' }
      ] // 资产状态
    };
  },
  created () {
    this.getList();
    Service.getSelectList('ASSETS_LARGE_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.assetsLargeTypearr = data;
        this.assetsLargeTypearr.map(res => {
          res.list.map(item => {
            this.TypeObj[`${res.code}-${item.code}`] = item.value;
            // console.log(this.TypeObj);
            item.list.map(subItem => {
              this.subTypeObj[`${res.code}-${item.code}-${subItem.code}`] = subItem.value;
            });
          });
        });
      }
    });
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    handleClick () {
      this.searchForm.type = Number(this.activeName);
      this.pageNo = 1;
      this.getList();
    },
    getList (page) {
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      AssetsService.getResourcesInfo(this.searchForm.pageSize, this.searchForm.pageNum, this.$route.query.id).then(res => {
        if (res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
          // console.log(this.tableList);
        } else {
          errorMessage(res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 详情
    goDetails (item) {
      this.$router.push({ path: '/person-center/resources-assets/detail?id='+item.id});
    },
    // 申请流转
    goApply (item) {
      // console.log(item);
      this.$router.push({ path: '/publish-project/project-info', query: { assetsCode: item.assetsCode } });
    },
    // 资源资产登记
    addAssets (e) {
      this.$router.push({ path: '/person-center/resources-assets/add?asstesType=' + e });
    },
    Goback () {
      this.$router.back();
    }
  }
};

